// Category of misconduct
export const CardCategory = {
    LABOR: 'labor',
    CONSUMER: 'consumer',
    ENVIRONMENT: 'environment',
    PROCUREMENT: 'procurement',
    PRIVACY: 'privacy',
    LOBBYING: 'lobbying',
    FRAUD: 'fraud',
    GOVERNANCE: 'governance',
    OTHER: 'other',
};
// Evidence card lifecycle status
export const CardStatus = {
    DRAFT: 'DRAFT',
    REVIEW: 'REVIEW',
    PUBLISHED: 'PUBLISHED',
    DISPUTED: 'DISPUTED',
    CORRECTED: 'CORRECTED',
    RETRACTED: 'RETRACTED',
    ARCHIVED: 'ARCHIVED',
};
// Entity type
export const EntityType = {
    CORPORATION: 'CORPORATION',
    AGENCY: 'AGENCY',
    NONPROFIT: 'NONPROFIT',
    VENDOR: 'VENDOR',
    INDIVIDUAL_PUBLIC_OFFICIAL: 'INDIVIDUAL_PUBLIC_OFFICIAL',
    PERSON: 'PERSON',
};
// Document type for sources
export const DocType = {
    PDF: 'PDF',
    HTML: 'HTML',
    IMAGE: 'IMAGE',
    OTHER: 'OTHER',
};
// Source verification status
export const VerificationStatus = {
    PENDING: 'PENDING',
    VERIFIED: 'VERIFIED',
    FAILED: 'FAILED',
};
// Evidence strength level
export const EvidenceStrength = {
    HIGH: 'HIGH',
    MEDIUM: 'MEDIUM',
    LOW: 'LOW',
};
// Relationship types between entities
export const RelationshipType = {
    OWNS: 'OWNS',
    CONTROLS: 'CONTROLS',
    SUBSIDIARY_OF: 'SUBSIDIARY_OF',
    ACQUIRED: 'ACQUIRED',
    DIVESTED: 'DIVESTED',
    JV_PARTNER: 'JV_PARTNER',
    AFFILIATED: 'AFFILIATED',
    PARENT_OF: 'PARENT_OF',
    CONTRACTOR_TO: 'CONTRACTOR_TO',
    REGULATED_BY: 'REGULATED_BY',
    BOARD_INTERLOCK: 'BOARD_INTERLOCK',
    LOBBIED_BY: 'LOBBIED_BY',
    OTHER: 'OTHER',
};
// Relationship status
export const RelationshipStatus = {
    DRAFT: 'DRAFT',
    PUBLISHED: 'PUBLISHED',
    RETRACTED: 'RETRACTED',
};
// Claim stance - who is making the claim
export const ClaimStance = {
    AGENCY_ALLEGES: 'AGENCY_ALLEGES',
    COURT_HELD: 'COURT_HELD',
    COMPANY_DISCLOSED: 'COMPANY_DISCLOSED',
    SETTLEMENT_TERMS: 'SETTLEMENT_TERMS',
    WHISTLEBLOWER_ALLEGED: 'WHISTLEBLOWER_ALLEGED',
    INSPECTOR_FOUND: 'INSPECTOR_FOUND',
    MEDIA_REPORTED: 'MEDIA_REPORTED',
};
// Claim type - category of the claim
export const ClaimType = {
    ENFORCEMENT_ACTION: 'ENFORCEMENT_ACTION',
    AUDIT_FINDING: 'AUDIT_FINDING',
    DISCLOSURE: 'DISCLOSURE',
    SETTLEMENT: 'SETTLEMENT',
    COURT_RULING: 'COURT_RULING',
    PENALTY: 'PENALTY',
    INJUNCTION: 'INJUNCTION',
    CONSENT_DECREE: 'CONSENT_DECREE',
    RECALL: 'RECALL',
    WARNING_LETTER: 'WARNING_LETTER',
    INVESTIGATION: 'INVESTIGATION',
};
// Monetary amount type
export const MonetaryAmountType = {
    PENALTY: 'PENALTY',
    SETTLEMENT: 'SETTLEMENT',
    RESTITUTION: 'RESTITUTION',
    DISGORGEMENT: 'DISGORGEMENT',
    OTHER: 'OTHER',
};
// Affected count unit
export const AffectedCountUnit = {
    INDIVIDUALS: 'INDIVIDUALS',
    ACCOUNTS: 'ACCOUNTS',
    TRANSACTIONS: 'TRANSACTIONS',
    FACILITIES: 'FACILITIES',
    PRODUCTS: 'PRODUCTS',
    OTHER: 'OTHER',
};
// Audit log action types
export const AuditAction = {
    CREATE_ENTITY: 'CREATE_ENTITY',
    UPDATE_ENTITY: 'UPDATE_ENTITY',
    CREATE_SOURCE: 'CREATE_SOURCE',
    UPDATE_SOURCE: 'UPDATE_SOURCE',
    UPLOAD_SOURCE: 'UPLOAD_SOURCE',
    VERIFY_SOURCE: 'VERIFY_SOURCE',
    CREATE_CARD: 'CREATE_CARD',
    UPDATE_CARD: 'UPDATE_CARD',
    SUBMIT_CARD: 'SUBMIT_CARD',
    PUBLISH_CARD: 'PUBLISH_CARD',
    DISPUTE_CARD: 'DISPUTE_CARD',
    CORRECT_CARD: 'CORRECT_CARD',
    RETRACT_CARD: 'RETRACT_CARD',
    ARCHIVE_CARD: 'ARCHIVE_CARD',
    RESTORE_CARD: 'RESTORE_CARD',
    REJECT_INTAKE: 'REJECT_INTAKE',
    PROMOTE_INTAKE: 'PROMOTE_INTAKE',
    RETRY_EXTRACTION: 'RETRY_EXTRACTION',
    CREATE_RELATIONSHIP: 'CREATE_RELATIONSHIP',
    UPDATE_RELATIONSHIP: 'UPDATE_RELATIONSHIP',
    PUBLISH_RELATIONSHIP: 'PUBLISH_RELATIONSHIP',
    RETRACT_RELATIONSHIP: 'RETRACT_RELATIONSHIP',
    ADMIN_LOGIN: 'ADMIN_LOGIN',
    ADMIN_LOGOUT: 'ADMIN_LOGOUT',
    MFA_RESET: 'MFA_RESET',
};
//# sourceMappingURL=enums.js.map